import { useAppContext } from '~/services/main/contexts/AppContext';
import {
  FeatureKey,
  useIsFeatureEnabledForPayload,
} from './useIsFeatureEnabledForPayload';

interface OrganizationComplianceDashboardAccess {
  canViewOrganizationComplianceDashboard: boolean;
  isCheckingAccess: boolean;
}

/**
 * Resolves whether the current user can access the production compliance
 * dashboard for the selected organization.
 */
export const useCanViewOrganizationComplianceDashboard =
  (): OrganizationComplianceDashboardAccess => {
    const {
      selectedOrganization,
      isSelectedOrgAdmin,
      loadingOrganizations,
      loadingIsSelectedOrgAdmin,
    } = useAppContext();
    const isComplianceDashboardEnabled = useIsFeatureEnabledForPayload({
      featureFlagKey: FeatureKey.ORG_COMPLIANCE_DASHBOARD,
      organizationId: selectedOrganization?.id,
    });
    const isCheckingAccess =
      loadingOrganizations ||
      loadingIsSelectedOrgAdmin ||
      isComplianceDashboardEnabled === undefined;

    const canViewOrganizationComplianceDashboard = Boolean(
      !isCheckingAccess &&
        selectedOrganization &&
        isSelectedOrgAdmin &&
        isComplianceDashboardEnabled === true
    );

    return {
      canViewOrganizationComplianceDashboard,
      isCheckingAccess,
    };
  };
